import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';

/**
 * Protected ops-dashboard shell: sidebar + scrollable content.
 * Shape mirrors Clinio V2 AdminLayout (sidebar + outlet), without platform-admin gate.
 */
export function AppLayout() {
  return (
    <div className="flex h-screen min-h-0 flex-col">
      <div className="flex min-h-0 flex-1">
        <Sidebar />
        <main className="flex min-w-0 flex-1 flex-col overflow-hidden bg-page-light dark:bg-page-dark">
          <div className="flex-1 overflow-y-auto px-8 pb-12 pt-6">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
